import { STORAGE_KEYS } from '@app/domain/ports';
import type { ICryptoAdapter, IMetadataKeyRepository } from '@app/domain/ports';

export class EncryptedDatabaseSnapshotReader {
  constructor(
    private readonly crypto: Pick<ICryptoAdapter, 'decryptRaw'>,
    private readonly metadataRepository: Pick<IMetadataKeyRepository, 'get'>,
  ) {}

  async load(dek: CryptoKey): Promise<Uint8Array | null> {
    const meta = await this.metadataRepository.get<{ iv: ArrayBuffer; data: ArrayBuffer }>(
      STORAGE_KEYS.DB_ENCRYPTED,
    );

    if (!meta) return null;

    return this.crypto.decryptRaw(new Uint8Array(meta.data), new Uint8Array(meta.iv), dek);
  }
}
